import { render, staticRenderFns } from "./DetailCategory.vue?vue&type=template&id=4a25c0df&scoped=true"
import script from "./DetailCategory.vue?vue&type=script&lang=ts"
export * from "./DetailCategory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a25c0df",
  null
  
)

export default component.exports